export const timeZoneOptions = [
  { id: 1, name: 'Eastern Time Zone (ET): UTC-5:00', key: 'EST' },
  { id: 2, name: 'Central Time Zone (CT): UTC-6:00', key: 'CT' },
  { id: 3, name: 'Mountain Time Zone (MT): UTC-7:00', key: 'MT' },
  { id: 4, name: 'Pacific Time Zone (PT): UTC-8:00', key: 'PT' },
  { id: 5, name: 'Alaska Time Zone (AKT): UTC-9:00', key: 'AKT' },
  { id: 6, name: 'Hawaii-Aleutian Time Zone (HAST): UTC-10:00', key: 'HAST' },
]
